import React from 'react';
import first_image from '../assets/images/main.svg';
import hdfc from '../assets/images/hdfc.png';
import icici from '../assets/images/icicilogo.png';
import digit from '../assets/images/social_share/digit.png';
import care from '../assets/images/social_share/care.png';
import kotak from '../assets/images/social_share/kotak.png';
import orient from '../assets/images/social_share/orient.png';
import tata from '../assets/images/tata.jpg';
import shriram from '../assets/images/shriram.png';
import bajaj from '../assets/images/bajaj.png';
import iffco from '../assets/images/iffco.webp';
import royal from '../assets/images/royal.png';
import relience from '../assets/images/relience.png';
import future from '../assets/images/future.png';
import cigna from '../assets/images/cigna.png';
import health_insurance from '../assets/images/health_insurance1.png';
import motor_insurance from '../assets/images/motor_insurance.png';
import Star from '../assets/images/Star.png';
import birla from '../assets/images/aditiya-birla-life-insurance-logo-web.webp';
import SBI from '../assets/images/SBI.png';
import { useState } from 'react';

function CompanyRenewalLinks() {
  const [activeTab, setActiveTab] = useState('tab1');
  //  Functions to handle Tab Switching
  const handleTab1 = () => {
    // update the state to tab1
    setActiveTab('tab1');
  };
  const handleTab2 = () => {
    // update the state to tab2
    setActiveTab('tab2');
  };
  return (
    <div className="w-full mt-12 ">
      <div className="Tabs1">
        <ul className="nav">
          <li
            className={activeTab === 'tab1' ? 'active' : ''}
            onClick={handleTab1}
          >
            Health Insurance
          </li>
          <li
            className={activeTab === 'tab2' ? 'active' : ''}
            onClick={handleTab2}
          >
            Motor Insurance
          </li>
        </ul>

        <div className="outlet">
          {activeTab === 'tab1' ? (
            <section
              // style={{ backgroundImage: `url(${people})` }}
              className="relative xl:h-[570px]  h-[400px] justify-center items-center  "
            >
              <section>
                <div className="renewal-page   ">
                  <div className="motor">
                    <div>
                      <div className="motor-heading mt-8">
                        <p>Renew Health Insurance</p>
                      </div>
                      <p className="select-heading">Select your insurer</p>
                      <div className="comp-map-card" style={{}}>
                        {[
                          {
                            url: care,
                            link: 'https://www.careinsurance.com/self-help-policy-verification.html?sub_category=renew_now',
                          },
                          {
                            url: cigna,
                            link: 'https://buyonline.manipalcigna.com/buy-health-insurance/renew',
                          },
                          {
                            url: Star,
                            link: 'https://www.starhealth.in/customerportal/instant-renewal',
                          },
                          {
                            url: birla,
                            link: 'https://www.adityabirlacapital.com/healthinsurance/buy-insurance-online/#!/renewal-renew-policy ',
                          },
                          {
                            url: tata,
                            link: 'https://www.tataaig.com/renewal?lob=health',
                          },
                          {
                            url: royal,
                            link: 'https://dtcapplive.royalsundaram.in/instarenew/home',
                          },
                          {
                            url: relience,
                            link: 'https://www.reliancegeneral.co.in/Insurance/Health-Insurance/Renewal-Online-Premium-Calculation.aspx',
                          },
                          {
                            url: icici,
                            link: 'https://www.icicilombard.com/health-insurance/renew-online#/Health',
                          },
                          { url: digit, link: '' },
                          {
                            url: SBI,
                            link: 'https://www.sbigeneral.in/online-insurance/healthrenewal/select-product',
                          },
                          {
                            url: hdfc,
                            link: 'https://www.hdfcergo.com/OnlineProducts/HealthOnline/renewal/HealthRenewal.aspx',
                          },

                          // { url: shriram },
                          // { url: bajaj },
                          // { url: iffco },

                          // { url: relience },
                          // { url: future },

                          // { url: care },
                          // { url: orient },
                        ].map((ele) => {
                          return (
                            <div className="comp-base">
                              <a
                                href={ele.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <div className="comp-card">
                                  <div style={{ width: '100px' }}>
                                    <img
                                      width="100px"
                                      height="auto"
                                      style={{ maxHeight: '60px' }}
                                      src={ele.url}
                                    />
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="motor-logo">
                    <img src={health_insurance} />
                  </div>
                </div>
              </section>
            </section>
          ) : (
            <section
              // style={{ backgroundImage: `url(${people})` }}
              className="relative xl:h-[570px]  h-[400px] justify-center items-center  "
            >
              <section>
                <div className="renewal-page">
                  <div className="motor">
                    <div>
                      <div className="motor-heading">
                        <p>Renew Motor Insurance</p>
                      </div>
                      <p className="select-heading">Select your insurer</p>
                      <div className="comp-map-card" style={{}}>
                        {[
                          { url: tata, link: 'https://www.tataaig.com/' },
                          {
                            url: hdfc,
                            link: 'https://www.hdfcergo.com/renew-hdfc-ergo-policy',
                          },
                          {
                            url: digit,
                            link: '',
                          },
                          {
                            url: icici,
                            link: 'https://www.icicilombard.com/renew-policy-online#/AllRenewal',
                          },
                          {
                            url: relience,
                            link: 'https://www.reliancegeneral.co.in/Insurance/Motor-Insurance/Renewal-Online-Premium-Calculation.aspx',
                          },
                          {
                            url: royal,
                            link: 'https://dtcapplive.royalsundaram.in/instarenew/home',
                          },
                        ].map((ele) => {
                          return (
                            <div className="comp-base">
                              <a
                                href={ele.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <div className="comp-card">
                                  <div style={{ width: '100px' }}>
                                    <img
                                      width="100px"
                                      height="auto"
                                      style={{ maxHeight: '60px' }}
                                      src={ele.url}
                                    />
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="motor-logo">
                    <img src={motor_insurance} />
                  </div>
                </div>
              </section>
            </section>
          )}
        </div>
      </div>

      {/* <section>
        <div className="h-[80px] bg-white">
          <div></div>
        </div>
      </section> */}
      {/* <section>
       
      </section> */}
    </div>
  );
}

export default CompanyRenewalLinks;
